import SplitPane from './SplitPane'

export default {
  name: 'split-pane',
  configure: function(config) {
    config.addComponent('split-pane', SplitPane)
  },
  SplitPane
}
